import React from 'react';
import FlatButton from 'material-ui/FlatButton';
import Transition from 'react-transition-group/Transition';
import DeleteIcon from 'material-ui/svg-icons/action/delete';
import CloseIcon from 'material-ui/svg-icons/navigation/close';
import NextIcon from 'material-ui/svg-icons/image/navigate-next';
import BeforeIcon from 'material-ui/svg-icons/image/navigate-before';

const transitionStyles = {
  entering: {opacity: 1, backgroundColor: 'rgba(0,0,0,0.5)'},
  entered: {opacity: 1, backgroundColor: 'rgba(0,0,0,0.5)'},
}

const TopToolbar = (props) => {
  return (
    <Transition in={props.toolbarVisible} timeout={400}>
      {
        (state) => {
          return(
            <div
              key={'topToolbar'}
              style={Object.assign({}, styles.topToolbar, transitionStyles[state])}>
              <FlatButton
                style={{ height: 60 }}
                onTouchTap={props.onDelete}>
                <DeleteIcon color={'white'} style={{width: 32, height: 32}}/>
              </FlatButton>
              <FlatButton
                style={{ height: 60 }}
                onTouchTap={props.onClose}>
                <CloseIcon color={'white'} style={{width: 32, height: 32}}/>
              </FlatButton>
            </div>
          )
        }
      }
    </Transition>
  )
}

const BottomToolbar = (props) => {
  // By the time, there is only one action in the bottom toolbar,
  // adding a download option would required to modify the implementation
  // to show only actions required by the calling component.
  return (
    <Transition in={props.toolbarVisible} timeout={400}>
      {
        (state) => {
          return (
            <div
              key={'bottomToolbar'}
              style={Object.assign({}, styles.bottomToolbar, transitionStyles[state])}>
              <FlatButton
                style={{ height: 60 }}
                onTouchTap={props.onLeftArrow}>
                <BeforeIcon color={'white'} style={{width: 32, height: 32}}/>
              </FlatButton>
              <FlatButton
                style={{ height: 60 }}
                onTouchTap={props.onRightArrow}>
                <NextIcon color={'white'} style={{width: 32, height: 32}}/>
              </FlatButton>
            </div>
          )

        }
      }
    </Transition>
  )
}

const styles = {
  bottomToolbar: {
    transition: 'opacity 400ms ease-in-out',
    opacity: 0,
    bottom: 0,
    backgroundColor: 'rgba(0,0,0,0.5)',
    position: 'absolute',
    width: 600,
    display: 'flex',
    justifyContent: 'flex-end'
  },
  topToolbar: {
    transition: 'opacity 400ms ease-in-out',
    opacity: 0,
    top: 0,
    backgroundColor: 'rgba(0,0,0,0.5)',
    position: 'absolute',
    width: 600,
    display: 'flex',
    justifyContent: 'space-between'
  }
}

export { TopToolbar, BottomToolbar }



// WEBPACK FOOTER //
// ./src/common/PhotoSlideShow/SlideShowTools.js